import { ListPageSkeleton, SidePanelSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * 资产管理页面骨架。
 *
 * 真实结构：`w-full h-full flex overflow-hidden gap-x-5 items-start`
 * → 左：`Card w-45 shrink-0 py-4 self-stretch`（`CardContent px-2 space-y-1` 内的竖排导航按钮）
 * → 右：`flex-1 min-w-0 flex flex-col h-full gap-3`，`h3` 标题 + `flex-1` 内的
 *   `TableCardLayout`（9 列；该页 `showViewOptions={false}`，筛选区右侧只有重置 / 搜索）。
 */
export function ResourceManagementSkeleton() {
  return (
    <div className="flex w-full h-full items-start gap-x-5 overflow-hidden">
      {/* 左侧资源类型导航 */}
      <SidePanelSkeleton
        widthClassName="w-45"
        withHeader={false}
        itemCount={6}
        itemHeight={36}
        className="self-stretch rounded-xl py-4"
      />

      {/* 右侧内容区 */}
      <div className="flex h-full max-h-full min-w-0 flex-1 flex-col gap-4 self-stretch overflow-hidden">
        <Skeleton className="h-5.5 w-24 shrink-0" />
        <div className="min-h-0 flex-1 overflow-hidden">
          {/* 实测默认资源类型 8 列：勾选 + 资源ID/资源名称/地区/创建人/创建时间/更新时间/操作 */}
          <ListPageSkeleton columnCount={8} />
        </div>
      </div>
    </div>
  );
}

export default ResourceManagementSkeleton;
